import GroupInfoUserInput from './GroupInfoUserInput';
import Styles from '../GroupInfoModal.module.css';

const GroupName = ({ adminControl, groupName, nameEdit, setNameEdit, inputGrouNameValue, setInputGrouNameValue, handleNameChange }) => {
  return adminControl ? (
    !nameEdit ? (
      <div className={Styles.icon_name_container}>
        <div className={Styles.groupNameEdit}>
          <span className={Styles.groupName}>{groupName}</span>
        </div>
        <svg className={Styles.group_name_edit_icon} onClick={() => setNameEdit(true)}>
          <use xlinkHref={`/assets/sprite.svg#icon-group-edit`} />
        </svg>
      </div>
    ) : (
      <div className={Styles.groupNameInput}>
        <GroupInfoUserInput inputValue={inputGrouNameValue} dynamicWidth={160} setInputGrouNameValue={setInputGrouNameValue} handleSubmit={handleNameChange} />
      </div>
    )
  ) : (
    <span className={Styles.groupName}>{groupName}</span>
  );
};

export default GroupName;
